const QuidSourceGenreType = Object.freeze({
  GENERAL: 'GENERAL',
  PRESS_RELEASE: 'PRESS_RELEASE',
  OPINION: 'OPINION',
  BLOG: 'BLOG',
  EVENT: 'EVENT',
  REPORT: 'REPORT',
  INTERVIEW: 'INTERVIEW',
  ANALYSIS: 'ANALYSIS',
  MESSAGE_BOARD: 'MESSAGE_BOARD',
  TRANSCRIPT: 'TRANSCRIPT',
  OTHER_GENRE: 'OTHER_GENRE'
})
export default QuidSourceGenreType
// RESERVE BELOW
